import React from 'react';
import ReactDOM from 'react-dom';
import App from './pages/App';
import { AppThemeProvider } from './theme/ThemeContext';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
   <React.StrictMode>
     <AppThemeProvider>
       <App />
     </AppThemeProvider>
   </React.StrictMode>,
   document.getElementById('root')
 );

// AIMS PWA — register the service worker for the offline app shell (Phase 0).
// Only active in production builds; a no-op during `npm start`.
// Per AIMS-Offline-Inspection.md §10 we do NOT auto-reload on update. Stash the
// waiting registration and notify the app so its update prompt can activate it
// at a safe moment (not mid-form, not with unsynced data).
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.__AIMS_SW_WAITING__ = registration;
    window.dispatchEvent(new CustomEvent('aims:sw-update', { detail: registration }));
  },
});